import React, { useState, useRef, useEffect } from "react";
import ImageGallery from "react-image-gallery";
import "react-image-gallery/styles/css/image-gallery.css";
import "./ImageGallery.css";
import { Modal } from "react-bootstrap"; // Import Modal from react-bootstrap

const images = [
    {
        original: "https://picsum.photos/id/1018/1000/600/",
        thumbnail: "https://picsum.photos/id/1018/250/150/",
    },
    {
        original: "https://picsum.photos/id/1015/1000/600/",
        thumbnail: "https://picsum.photos/id/1015/250/150/",
    },
    {
        original: "https://picsum.photos/id/1019/1000/600/",
        thumbnail: "https://picsum.photos/id/1019/250/150/",
    },
    {
        original: "https://picsum.photos/id/1018/1000/600/",
        thumbnail: "https://picsum.photos/id/1018/250/150/",
    },
    {
        original: "https://picsum.photos/id/1015/1000/600/",
        thumbnail: "https://picsum.photos/id/1015/250/150/",
    },
    {
        original: "https://picsum.photos/id/1019/1000/600/",
        thumbnail: "https://picsum.photos/id/1019/250/150/",
    },
    {
        original: "https://picsum.photos/id/1018/1000/600/",
        thumbnail: "https://picsum.photos/id/1018/250/150/",
    },
    {
        original: "https://picsum.photos/id/1015/1000/600/",
        thumbnail: "https://picsum.photos/id/1015/250/150/",
    },
    {
        original: "https://picsum.photos/id/1019/1000/600/",
        thumbnail: "https://picsum.photos/id/1019/250/150/",
    },
    {
        original: "https://picsum.photos/id/1018/1000/600/",
        thumbnail: "https://picsum.photos/id/1018/250/150/",
    },
    {
        original: "https://picsum.photos/id/1015/1000/600/",
        thumbnail: "https://picsum.photos/id/1015/250/150/",
    },
    {
        original: "https://picsum.photos/id/1019/1000/600/",
        thumbnail: "https://picsum.photos/id/1019/250/150/",
    },
];

const MyGallery = ({postImages}) => {
    const [isModalOpen, setIsModalOpen] = useState(false);
    const galleryRef = useRef(null); // Create a ref for the ImageGallery component\

    postImages = JSON.parse(postImages);
    const images = postImages.map((imageName) => ({
        original: `${process.env.REACT_APP_API_URL}/photos/resized_${imageName}`,
        thumbnail:`${process.env.REACT_APP_API_URL}/photos/thumbnail_${imageName}`,
    }));

    const imagesFullscreen = postImages.map((imageName) => ({
        original: `${process.env.REACT_APP_API_URL}/photos/${imageName}`,
        thumbnail:`${process.env.REACT_APP_API_URL}/photos/thumbnail_${imageName}`,
    }));

    const galleryStyles = {
        width: "80%",
        margin: "0", // Remove auto margins to align left
        alignSelf: "flex-end",
    };

    const renderFullscreenButton = (onClick) => (
        <button
            type="button"
            className="image-gallery-icon image-gallery-fullscreen-button"
            onClick={() => setIsModalOpen(true)} // Correctly open modal
        >
            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-fullscreen" viewBox="0 0 16 16">
                <path d="M1.5 1a.5.5 0 0 0-.5.5v4a.5.5 0 0 1-1 0v-4A1.5 1.5 0 0 1 1.5 0h4a.5.5 0 0 1 0 1zM10 .5a.5.5 0 0 1 .5-.5h4A1.5 1.5 0 0 1 16 1.5v4a.5.5 0 0 1-1 0v-4a.5.5 0 0 0-.5-.5h-4a.5.5 0 0 1-.5-.5M.5 10a.5.5 0 0 1 .5.5v4a.5.5 0 0 0 .5.5h4a.5.5 0 0 1 0 1h-4A1.5 1.5 0 0 1 0 14.5v-4a.5.5 0 0 1 .5-.5m15 0a.5.5 0 0 1 .5.5v4a1.5 1.5 0 0 1-1.5 1.5h-4a.5.5 0 0 1 0-1h4a.5.5 0 0 0 .5-.5v-4a.5.5 0 0 1 .5-.5" />
            </svg>
        </button >
    );

    const renderExitFullscreenButton = (onClick) => (
        <button
            type="button"
            className="image-gallery-icon image-gallery-fullscreen-button"
            onClick={() => setIsModalOpen(false)} // Properly close modal
        >
            <svg xmlns="http://www.w3.org/2000/svg" width="30" height="30" fill="currentColor" class="bi bi-arrows-angle-contract" viewBox="0 0 16 16">
                <path fill-rule="evenodd" d="M.172 15.828a.5.5 0 0 0 .707 0l4.096-4.096V14.5a.5.5 0 1 0 1 0v-3.975a.5.5 0 0 0-.5-.5H1.5a.5.5 0 0 0 0 1h2.768L.172 15.121a.5.5 0 0 0 0 .707M15.828.172a.5.5 0 0 0-.707 0l-4.096 4.096V1.5a.5.5 0 1 0-1 0v3.975a.5.5 0 0 0 .5.5H14.5a.5.5 0 0 0 0-1h-2.768L15.828.879a.5.5 0 0 0 0-.707" />
            </svg>
        </button>
    );

    const renderRightNav = (onClick, disabled) => (
        <button
            type="button"
            className="image-gallery-icon image-gallery-right-nav"
            disabled={disabled}
            onClick={onClick}
        >
            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-arrow-right-circle-fill" viewBox="0 0 16 16">
                <path d="M8 0a8 8 0 1 1 0 16A8 8 0 0 1 8 0M4.5 7.5a.5.5 0 0 0 0 1h5.793l-2.147 2.146a.5.5 0 0 0 .708.708l3-3a.5.5 0 0 0 0-.708l-3-3a.5.5 0 1 0-.708.708L10.293 7.5z" />
            </svg>
        </button>
    );

    const renderLeftNav = (onClick, disabled) => (
        <button
            type="button"
            className="image-gallery-icon image-gallery-left-nav"
            disabled={disabled}
            onClick={onClick}
        >
            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-arrow-left-circle-fill" viewBox="0 0 16 16">
                <path d="M8 0a8 8 0 1 0 0 16A8 8 0 0 0 8 0m3.5 7.5a.5.5 0 0 1 0 1H5.707l2.147 2.146a.5.5 0 0 1-.708.708l-3-3a.5.5 0 0 1 0-.708l3-3a.5.5 0 1 1 .708.708L5.707 7.5z" />
            </svg>
        </button>
    );

    return (
        <div style={galleryStyles}>
            <ImageGallery
                ref={galleryRef}
                items={images}
                autoPlay={true}
                showNav={true}
                showPlayButton={false}
                thumbnailPosition="right"
                renderFullscreenButton={renderFullscreenButton} // Custom fullscreen button
                renderRightNav={renderRightNav} // Custom right navigation button
                renderLeftNav={renderLeftNav} // Custom left navigation button
            />

            <Modal
                show={isModalOpen}
                onHide={() => setIsModalOpen(false)} // Close modal on hide
                size="xl"
                centered
                aria-labelledby="fullscreen-modal"
            >
                <Modal.Body className="d-flex justify-content-center">
                    <ImageGallery
                        items={imagesFullscreen}
                        showFullscreenButton={true}
                        useBrowserFullscreen={false}
                        showPlayButton={false}
                        showNav={true} // Allow navigation within the modal
                        additionalClass="fullscreenGalleryStyles"
                        startIndex={galleryRef.current ? galleryRef.current.getCurrentIndex() : 0} // Set the current index to the same as the main gallery
                        renderFullscreenButton={renderExitFullscreenButton} // Custom exit fullscreen button
                    />
                </Modal.Body>
            </Modal>
        </div>
    );
};

export default MyGallery;
